<template>
    <section class="blockElement fix-mt">
        <div class="customFlex-wrapper">
          <app-LeftNavigation></app-LeftNavigation>
			    <div class="rightArea dashboard justify-content-center row vh_100 whiteBG pr-2 pl-0">
            <div class="col-12 p-0">
              <app-header :pageName="pageTitle"></app-header>
              <router-view/>
            </div>
          </div> 
        </div>
    </section>
</template>
<script>
  //import WOW from '../../../static/common/js/wow.min.js'
	import LeftNavigation from './shared/left_navigation'
  import { fxViewMixins } from '@/plugins/fxView'
  import * as types from '../../types'
  export default {
    name: 'fxViewApp',
    mixins: [fxViewMixins],
    data() {
        return {  
          pageTitle : ''
        }
    },
    components: {    
      appLeftNavigation: LeftNavigation,   
    },
	methods:{
		groupAdminNameFunc(){
			this._runGetGroupAdminName({'globalParams' : {} ,'localParams' : {'parameter' : this , 'page' : ''}})
		},
	},
	created(){
		this.$store.dispatch(types.RUN_STATE_LOAD)
		this._runGetTicketReasonList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
    this._runTicketReasonList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
		this._runGetCountriesList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
		this.groupAdminNameFunc()
    this._runGetNotificationList({'globalParams' : { page: 1, perPage: 5, read : 0 } ,'localParams' : {'parameter' : this}})

    this._runGetTutCourse({'globalParams' : {'page' : 1 , 'pageLimit' :15} ,'localParams' : {'parameter' : this}})
    this._runGetTutCat({'globalParams' : {'page' : 1 , 'pageLimit' :15} ,'localParams' : {'parameter' : this}})
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/fxView/index.vue